import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {SymbolContainer} from "../reels/SymbolContainer";
import {SYMBOL} from "../enums/Enum";
import {GameUtils} from "../utils/GameUtils";
import {Sound} from "../sound/Sound";

export class XWaysRevealRunner implements SimplePresentationRunner {
    private _isXWaysPlaying: boolean = false;

    shouldRun(): boolean {
        return true;
    }

    start(flowStateController: SimplePresentationRunnerController): void {
        const enhancerXWaysArr: number[] = this.getEnhancerXWays();
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            flowStateController.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });

        Game.model.s2InReels.forEach((rowId: number, index: number) => {
            if (rowId != -1) {
                const reelId: number = index === 0 ? 1 : 3;
                const featureTriggeredArr = index === 0 ? Game.model.gameData.firstS2FeatureTriggered : Game.model.gameData.secondS2FeatureTriggered;
                if (featureTriggeredArr.indexOf(SYMBOL.X_WAYS) > -1) {
                    tl.add(this.playXWaysFromS2(reelId, rowId), 0)
                }
            }
        });

        let isXWaysAvailableInEnhancer: boolean = false;
        enhancerXWaysArr.forEach((rowId: number, reelId: number) => {
            if (rowId != -1) {
                isXWaysAvailableInEnhancer = true;
                tl.add(this.playXWays(reelId, rowId), 0);
            }
        });

        if (isXWaysAvailableInEnhancer) {
            if (!this._isXWaysPlaying) {
                this._isXWaysPlaying = true;
                tl.add(() => {
                    Game.soundPlayer.playSound(Sound.X_WAYS_EXPLODE);
                }, 0.25);
                tl.add(() => {
                    Game.soundPlayer.playSound(Sound.X_WAYS_REVEAL);
                }, 0.36);
            }
        }

        tl.add(()=>{
            this.distributeMultiplier(enhancerXWaysArr, flowStateController);
        });
    }

    private distributeMultiplier(enhancerXWaysArr : number[], flowStateController:SimplePresentationRunnerController):void{
        const multiplierDistributionTl: gsap.core.Timeline = new gsap.core.Timeline();
        //distributeMultiplier
        if (Game.model.isStickyDeadApplicable() && Game.model.stickyDeadSymInfoCopy[Game.model.gameData.mysterySymbolRevealed]) {
            Game.model.s2InReels.forEach((rowId: number, index: number) => {
                if (rowId != -1) {
                    const reelId: number = index === 0 ? 1 : 3;
                    const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, rowId);
                    multiplierDistributionTl.add(Game.stickyView.checkAndSetStickyDeadMultiplierToSymbol(symbolContainer));
                }
            });

            enhancerXWaysArr.forEach((rowId: number, reelId: number) => {
                if (rowId != -1) {
                    const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, rowId);
                    multiplierDistributionTl.add(Game.stickyView.checkAndSetStickyDeadMultiplierToSymbol(symbolContainer));
                }
            });
        }
        multiplierDistributionTl.add(() => {
            Game.foregroundElements.waysCounter.updatePossibleWaysCounter(false, true, false);
            this._isXWaysPlaying = false;
            flowStateController.finish();
        })

    }

    public playXWaysFromS2(reelId: number, rowId: number): gsap.core.Timeline {
        const featureTl: gsap.core.Timeline = new gsap.core.Timeline();
        const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, rowId);
        symbolContainer.symbols.forEach((sym, subRowID: number) => {
            if (sym.symbolName === SYMBOL.X_WAYS) {
                featureTl.add(symbolContainer.playXWaysEffects(sym, subRowID), 0);
            }
        });

        featureTl.add(symbolContainer.revealMysterySymbolFromS2(Game.model.gameData.mysterySymbolRevealed), 0.9);
        // if (Game.model.isStickyDeadApplicable() && Game.model.stickyDeadSymInfoCopy[Game.model.gameData.mysterySymbolRevealed]) { //distribute sticky dead multiplier
        //     featureTl.add(() => {
        //         Game.stickyView.checkAndSetStickyDeadMultiplierToSymbol(symbolContainer);
        //     });
        // }
        if (!this._isXWaysPlaying) {
            this._isXWaysPlaying = true;
            featureTl.add(() => {
                Game.soundPlayer.playSound(Sound.X_WAYS_EXPLODE);
            }, 0.25);
            featureTl.add(() => {
                Game.soundPlayer.playSound(Sound.X_WAYS_REVEAL)
            });
        }
        return featureTl;
    }

    public playXWays(reelId: number, rowId: number): gsap.core.Timeline {
        const featureTl: gsap.core.Timeline = new gsap.core.Timeline();
        const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, rowId);
        symbolContainer.symbols.forEach((sym, subRowID: number) => {
            if (sym.symbolName === SYMBOL.X_WAYS) {
                featureTl.add(symbolContainer.playXWaysEffects(sym, subRowID), 0);
            }
        });
        Game.foregroundElements.waysCounter.symCountInReels[reelId]++;
        Game.foregroundElements.waysCounter.symCountInReels[reelId]++;
        featureTl.add(symbolContainer.revealMysterySymbol(Game.model.gameData.mysterySymbolRevealed), 0.25);
        // if (Game.model.isStickyDeadApplicable() && Game.model.stickyDeadSymInfoCopy[Game.model.gameData.mysterySymbolRevealed]) { //distribute sticky dead multiplier
        //     featureTl.add(() => {
        //         Game.stickyView.checkAndSetStickyDeadMultiplierToSymbol(symbolContainer);
        //     });
        // }
        // featureTl.add(() => {
        //     Game.foregroundElements.waysCounter.updatePossibleWaysCounter();
        // })
        return featureTl;
    }

    private revealAllXWays(): gsap.core.Timeline {
        const xWaysTl: gsap.core.Timeline = new gsap.core.Timeline();
        if (Game.model.fireFrameCount >= 4 && Game.model.enhancerFeatures[0] === SYMBOL.X_WAYS) {
            xWaysTl.add(this.playXWays(1, 2), 0);
        }
        if (Game.model.fireFrameCount >= 8 && Game.model.enhancerFeatures[1] === SYMBOL.X_WAYS) {
            xWaysTl.add(this.playXWays(2, 3), 0);
        }
        if (Game.model.fireFrameCount >= 6 && Game.model.enhancerFeatures[2] === SYMBOL.X_WAYS) {
            xWaysTl.add(this.playXWays(3, 2), 0);
        }
        if (xWaysTl.totalDuration() > 0.1 && !this._isXWaysPlaying) {
            this._isXWaysPlaying = true;
            xWaysTl.add(() => {
                Game.soundPlayer.playSound(Sound.X_WAYS_EXPLODE);
            }, 0.25);
            xWaysTl.add(() => {
                Game.soundPlayer.playSound(Sound.X_WAYS_REVEAL);
            }, 0.36);
        }
        return xWaysTl;
    }

    private getEnhancerXWays(): number[] {
        const xWaysArr: number[] = [-1, -1, -1, -1, -1];
        if (Game.model.fireFrameCount >= 4 && Game.model.enhancerFeatures[0] === SYMBOL.X_WAYS) {
            xWaysArr[1] = 2;
        }
        if (Game.model.fireFrameCount >= 8 && Game.model.enhancerFeatures[1] === SYMBOL.X_WAYS) {
            xWaysArr[2] = 3;
        }
        if (Game.model.fireFrameCount >= 6 && Game.model.enhancerFeatures[2] === SYMBOL.X_WAYS) {
            xWaysArr[3] = 2;
        }
        return xWaysArr;
    }

    private onSkip(tl: gsap.core.Timeline) {
        tl.timeScale(10);
    }

}